import { SelectBox } from "devextreme-react/select-box";
import { TextBox } from "devextreme-react/text-box";
import { ValidationGroup } from "devextreme-react/validation-group";
import { RequiredRule, Validator } from "devextreme-react/validator";
import { useContext, useState } from 'react';
import { useGetLocations } from '../../../../api/location';
import { useAuth } from '../../../../contexts/auth';
import { Field, Panel } from '../../../../layouts';
import { MaterialOrderContext } from '../context/MaterialOrderContext';

export default function NewCFIInformationPanel() {

	const { order, modifyOrder } = useContext(MaterialOrderContext);
	let [shipToLocationID, setShipToLocation] = useState(order.details.shipToLocationID);
	const { user } = useAuth();
	const locations = useGetLocations(user?.companyId!);

	return (
		<>
			<Panel
				header={'CFI Information'}
			>
				<ValidationGroup>
					<Field label={'Material PO Number'} >
						<TextBox inputAttr={{ 'data-testid': 'txt-material-po-number' }}
							className='required'
							value={order.details.COMPONumber}
							onValueChanged={(e) => modifyOrder({ ...order.details, COMPONumber: e.value })}
						>
							<Validator validationGroup='newMaterialOrderValidationGroup'>
								<RequiredRule message={'Material PO Number is required'}></RequiredRule>
							</Validator>
						</TextBox>
					</Field>
					<Field label={'Ship To Location'} >
						<SelectBox elementAttr={{ 'data-testid': 'dd-ship-to-location' }}
							className='required'
							dataSource={locations.data}
							valueExpr='locationID'
							displayExpr='locationName'
							value={shipToLocationID}
							onValueChanged={(e) => {
								setShipToLocation(e.value);
								const taxRate = locations.data.find((x) => x.locationID === e.value)?.taxRate;
								modifyOrder({ ...order.details, shipToLocationID: e.value, taxRate: taxRate }, true);
							}}
						>
							<Validator validationGroup='newMaterialOrderValidationGroup'>
								<RequiredRule message={'Ship To Location is required'}></RequiredRule>
							</Validator>
						</SelectBox>
					</Field>
				</ValidationGroup>
			</Panel>
		</>
	);
}
